import api from "./apiHelper";
const instance = api;

const apis = {
  getKnowledgebase: (projectId) => {
    return instance
      .get(`/api/knowledge-base?projectId=${projectId}`)
      .then((res) => res)
      .catch((error) => error);
  },
  createDocument: (projectId, payload, callback) => {
    return instance
      .post(
        `/api/knowledge-base/text-document?projectId=${projectId}`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            callback(progressEvent);
          },
        }
      )
      .then((res) => res)
      .catch((error) => error);
  },
  deleteDocument: (documentId) => {
    return instance
      .delete(`/api/knowledge-base/${documentId}`)
      .then((res) => res)
      .catch((error) => error);
  },
  searchDocument: (projectId, searchText) => {
    return instance
      .get(
        `/api/knowledge-base/search?projectId=${projectId}&search=${searchText}`
      )
      .then((res) => res)
      .catch((error) => error);
  },
  getLinkByURL: (url) => {
    return instance
      .post(`/api/knowledge-base/retrieve-web-url`, { url })
      .then((res) => res)
      .catch((error) => error);
  },
  createDataFromURLs: (urls, projectId) => {
    return instance
      .post(`/api/knowledge-base/web-url`, { urls, projectId })
      .then((res) => res)
      .catch((error) => error);
  },
  createManualQA: (question, answer, projectId) => {
    return instance
      .post(`/api/knowledge-base/manual-qa`, { projectId, question, answer })
      .then((res) => res)
      .catch((error) => error);
  },
  chatComment: (
    data = {
      likedOrDisliked: String,
      id: String,
      question: String,
      answer: String,
      comment: String,
      projectId: String,
    }
  ) => {
    return instance
      .post(`/api/feedback`, data)
      .then((res) => res)
      .catch((error) => error);
  },
  getFeedback: (projectId) => {
    return instance
      .get(`/api/feedback?projectId=${projectId}`)
      .then((res) => res)
      .catch((error) => error);
  },
  deleteFeedback: (feedbackId) => {
    return instance
      .delete(`/api/feedback/${feedbackId}`)
      .then((res) => res)
      .catch((error) => error);
  },
  getUsage: (date, projectId) => {
    return instance
      .get(`/api/usage?month=${date}&projectId=${projectId}`)
      .then((res) => res)
      .catch((error) => error);
  },
  getConversationHistory: (day, projectId) => {
    return instance
      .get(
        `/api/usage/conversation-history?dayLimit=${day}&projectId=${projectId}`
      )
      .then((res) => res)
      .catch((error) => error);
  },
};
export default apis;
